import { t } from "components/CentralDataMangement/translation/Translation";
import Button from "components/common/atoms/Button";
import Calender from "components/common/molecules/Calender";
import { LabelWithInputField } from "components/common/molecules/LabelWithInputField";
import React from "react";
import AddPlusIcon from "static/images/AddPlusIcon";
import DeleteIcon from "static/images/DeleteIcon";

interface ExtraData {
  fromDate: Date | null;
  toDate: Date | null;
  info: string;
}

interface Props {
  extraData: ExtraData[];
  handleChangeExtraData: (
    value: string | Date | null,
    name: string,
    index: number,
    type: string
  ) => void;
  addAnotherExtraData: (data: any) => void;
  removeExtraData: (index: number, data: any) => void;
  type: string;
  error?: string;
}

const AddExtraData: React.FC<Props> = ({
  extraData,
  handleChangeExtraData,
  addAnotherExtraData,
  removeExtraData,
  type,
  error
}) => {
  return (
    <>
      {extraData.map((item, index) => (
        <div
          className="d-grid hideHeight hideLabel"
          key={index}
          style={{ marginTop: "0.5vw", gridTemplateColumns: "1fr 1fr 1fr 0.5fr", gap:"0 0.5vw" }}
        >
          {/* Calendar Input */}
          <div className="position-relative  calendarIconWithoutLabel">
            <Calender
              onChange={(e) =>
                handleChangeExtraData(e, "fromDate", index, type)
              }
              isMandatory={false}
              name="fromDate"
              isDisabled={false}
              selectedDate={
                item.fromDate != null ? new Date(item.fromDate) : null
              }
              onCalendarClick={() => {}} // Pass the callback
            />
          </div>
          <div className="position-relative  calendarIconWithoutLabel">
            <Calender
              onChange={(e) => handleChangeExtraData(e, "toDate", index, type)}
              isMandatory={false}
              name="toDate"
              isDisabled={false}
              minDate={item.fromDate}
              selectedDate={item.toDate != null ? new Date(item.toDate) : null}
              onCalendarClick={() => {}} // Pass the callback
            />
          </div>

          {/* Info Input Field */}
          <div className="position-relative ">
            <LabelWithInputField
              name="info"
              handleChange={(e) =>
                handleChangeExtraData(e.target.value, "info", index, type)
              }
              value={item.info}
              id={`info-${index}`}
              placeholder={t("Enter info")}
              type="text"
            />
          </div>

          {/* Action Buttons */}
          <div
            style={{ marginTop: "0.1vw" }}
          >
            {index > 0 && (
              <Button
                className="btn p-0 border-0 table-action-icons weeklyPlanningDeleteIcon marginRightPoint5"
                handleClick={() => removeExtraData(index, type)}
              >
                <span title={t("Remove")}>
                  <DeleteIcon />
                </span>
              </Button>
            )}
            {index === extraData.length - 1 && (
              <Button
                className="btn p-0 border-0 table-action-icons weeklyPlanningDeleteIcon"
                handleClick={() => addAnotherExtraData(type)}
              >
                <span title={t("Add another")}>
                  <AddPlusIcon />
                </span>
              </Button>
            )}
          </div>
        </div>
      ))}
      {error && ( <span className="text-danger">{error}</span> )}
    </>
  );
};

export default AddExtraData;
